import { ITEM_TYPE } from '@beef/shop-common';

import pushEvent, { EVENT_ADD_TO_CART } from 'pushEvent';

import { selectServiceById } from './selectors';
import { TOGGLE_SERVICE } from './constants';
import { getActiveServiceIds } from '../selectors';

/**
 * add/remove a service to the basket
 */
export const toggleService =
  ({ id, value }) =>
  (dispatch, getState) => {
    console.assert(typeof id === 'string', 'ServiceId must be a string in call to toggle service');
    const state = getState();
    let activeServiceIds = getActiveServiceIds(state);
    if (activeServiceIds.indexOf(id) !== -1) {
      /** service was active */
      if (value !== true) {
        // remove service from list
        activeServiceIds = activeServiceIds.filter((el) => el !== id);
      } else {
        // do nothing, service is already active
      }
    } else if (value !== false) {
      /** service was inactive */
      // add service to list
      // activeServiceIds = [...activeServiceIds, id];
      // only one service can be active
      activeServiceIds = [id];
    } else {
      // do nothing, service is already inactive
    }

    const serviceInfo = selectServiceById(state, id);

    if (value) {
      pushEvent(EVENT_ADD_TO_CART, {
        ...serviceInfo,
        name: serviceInfo?.title,
        itemType: ITEM_TYPE.SERVICE,
      });
    }

    dispatch({
      type: TOGGLE_SERVICE,
      id,
      value,
      activeServiceIds,
    });
  };

export const toggleInsurance = toggleService;
